import React, { useState } from 'react';
import './css/index.scss';
import moment from 'moment/moment';
import MyButton from '../../../../components/MyButton';
import { REPORT_MODAL_STATES } from '../../constants';
import ReportsModal from '../ReportsModal';
import Api from '../../../../Api';
import { resolvePhotoUrl } from '../../../../helpers/resolvePhotoUrl';
import { UNNAMED_USER_EMAIL } from '../../../../helpers/constants';

function ReportPhotos({ complaints, updateComplaints }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalState, setModalState] = useState('');
  const [selectedPhoto, setSelectedPhoto] = useState({});
  const [complaintId, setComplaintId] = useState(null);

  const onDeleteClick = (complaint) => {
    setModalState(REPORT_MODAL_STATES.approve);
    setIsModalVisible(true);
    setComplaintId(complaint);
  };

  const onLeaveClick = (complaint) => {
    if (complaint) {
      setModalState(REPORT_MODAL_STATES.decline);
      setIsModalVisible(true);
      setComplaintId(complaint);
    }
  };
  const onPhotoItemClick = (photo, complaint) => () => {
    setSelectedPhoto(photo);
    setModalState(REPORT_MODAL_STATES.viewPhoto);
    setIsModalVisible(true);
    setComplaintId(complaint);
  };

  return (
    <>
      <ReportsModal
        isVisible={isModalVisible}
        setIsVisible={setIsModalVisible}
        modalState={modalState}
        selectedPhoto={selectedPhoto}
        setSelectedPhoto={setSelectedPhoto}
        complaintId={complaintId}
        updateComplaints={updateComplaints}
        modalApproveInfoText="Вы уверены что хотите оставить эту фотографию?"
        modalDeleteInfoText="Вы уверены что хотите удалить эту фотографию? Отменить данное действие будет невозможно"
        subjectType="photo"
      />

      {complaints?.length ? complaints.map((complaint, index) => (
        <div key={complaint._id} className="report_photos">
          <div className="report_item_review">
            <p className="report_item_review_title">{complaint.subject.from_user?.display_name}</p>
            <div className="report_item_review_rating">
              <p className="report_item_review_rating_date">
                {' '}
                {moment(complaint.updatedAt).format('DD/MM/YYYY')}
              </p>
            </div>
            <div className="report_item_review_gallery">
              {(() => {
                const photoSrc = resolvePhotoUrl(complaint.subject, Api.url);
                return photoSrc ? (
                  <img
                    src={photoSrc}
                    alt=""
                    className="report_item_review_gallery_image"
                    onClick={onPhotoItemClick(complaint.subject, complaint._id)}
                  />
                ) : null;
              })()}
            </div>
          </div>

          <div className="report_item_info">
            <div className="report_item_info_block">
              <div className="report_item_info_block_first">
                <p className="report_item_info_title">{complaint.type === 'wrong' ? 'Недостоверная информация' : 'Оскорбительная информация'}</p>
                <p className="report_item_info_subtitle">Причина</p>
              </div>
              <div>
                <p className="report_item_info_title">
                  {moment(complaint.createdAt).format('DD/MM/YYYY')}
                </p>
                <p className="report_item_info_subtitle">Дата</p>
              </div>
            </div>
            {complaint.subject.organization?._id && (
            <>
              <div>
                <p className="report_item_info_title">{complaint.subject.organization.name}</p>
                <p className="report_item_info_subtitle">Предложение</p>
              </div>
              <div>
                <p className="report_item_info_title">{complaint.subject.organization._id}</p>
                <p className="report_item_info_subtitle">ID Предложения</p>
              </div>
            </>
            )}
            {complaint.subject.event?._id && (
            <>
              <div>
                <p className="report_item_info_title">{complaint.subject.event.name}</p>
                <p className="report_item_info_subtitle">Мероприятие</p>
              </div>
              <div>
                <p className="report_item_info_title">{complaint.subject.event._id}</p>
                <p className="report_item_info_subtitle">ID Мероприятия</p>
              </div>
            </>
            )}
            {complaint.from_user?.email && complaint.from_user?.email !== UNNAMED_USER_EMAIL && (
            <div>
              <p className="report_item_info_title">{complaint.from_user?.email}</p>
              <p className="report_item_info_title">{complaint.from_user?.display_name}</p>

              <p className="report_item_info_subtitle">Заявитель</p>
            </div>
            )}
          </div>
          <div className="report_buttons">
            <MyButton
              text="Оставить"
              secondary
              className="report_buttons_primary"
              onClick={() => onLeaveClick(complaint._id)}
            />
            <MyButton
              text="Удалить"
              className="report_buttons_secondary"
              onClick={() => onDeleteClick(complaint._id)}
            />
          </div>
        </div>
      )) : <p style={{ marginTop: 40, marginLeft: 10 }}>Пусто.</p>}
    </>
  );
}

export default ReportPhotos;
